import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext, StateToken } from '@ngxs/store';
import { Observable, of, tap } from 'rxjs';
import { ModuleType } from '../../enum/module-type.enum';
import { IModuleModel } from '../../interface/module/module.model';
import { ModulePwaSettings } from '../../interface/module/settings/module-pwa-settings';
import { SharedAppStateModel } from './app-state.model';
import { SharedAppActions } from './app.actions';

const SHARED_APP_STATE_TOKEN = new StateToken<SharedAppStateModel>('SharedAppState');

const DEFAULT_STATE: SharedAppStateModel = {
    appInitError: false,
    appModules: undefined,
};

@State<SharedAppStateModel>({
    name: SHARED_APP_STATE_TOKEN,
    defaults: DEFAULT_STATE,
})
@Injectable()
export class SharedAppState {
    @Selector([SHARED_APP_STATE_TOKEN])
    public static appModules$(state: SharedAppStateModel): IModuleModel<unknown>[] | undefined {
        return state.appModules;
    }

    @Selector([SHARED_APP_STATE_TOKEN])
    public static appPwaSettings$(state: SharedAppStateModel): ModulePwaSettings | undefined {
        return state.appModules?.find(module => module.module === ModuleType.MCA_CONFIG)?.settings as ModulePwaSettings;
    }

    @Selector([SHARED_APP_STATE_TOKEN])
    public static appInitError$(state: SharedAppStateModel): boolean {
        return state.appInitError;
    }

    @Action(SharedAppActions.SetApplicationModules)
    public setApplicationModules$(
        ctx: StateContext<SharedAppStateModel>,
        action: SharedAppActions.SetApplicationModules,
    ): Observable<IModuleModel[]> {
        return of(action.modules).pipe(tap(() => ctx.patchState({ appModules: action.modules })));
    }

    @Action(SharedAppActions.SetAppInitError)
    public setAppInitError$(ctx: StateContext<SharedAppStateModel>): void {
        ctx.patchState({ appInitError: true });
    }
}
